export enum PaymentMethodTypeEnum {
  Cash = 1,
  Cheque = 2,
  CreditCard = 3,
  Eft = 4,
  PreAuthorizedDebit = 5,
  // TODO: SPP-3497 hardcoded for now
  BankDraft = 6,
  Wire = 7,
  Other = 8
}
